import { render, staticRenderFns } from "./InsightLinkTile.vue?vue&type=template&id=debc070e&"
import script from "./InsightLinkTile.vue?vue&type=script&lang=js&"
export * from "./InsightLinkTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports